import { useMemo } from 'react';

import { countersApi } from './counters';

/**
 * Best-effort suggestions for a contact field, sourced from the `contact.{path}`
 * counter table (row values in the table's default language, falling back to the
 * row key). `path` is the dot-path under `contact` (e.g. `profile.gender`, `tags`).
 * Returns empty suggestions and `hasTable: false` when no such table exists —
 * callers keep free-text input working regardless.
 */
export function useContactFieldSuggestions(path: string) {
  const { data: table } = countersApi.useTable(`contact.${path}`);
  const suggestions = useMemo(() => {
    const lang = table?.defaultLang ?? '';
    return (table?.rows ?? [])
      .map((r) => r.value?.[lang] || r.key)
      .filter((s): s is string => !!s);
  }, [table]);
  return { suggestions, hasTable: !!table };
}
